// CoursesSection
import React from "react";

const courses = [
  { icon: "💡", title: "Trading", desc: "Learn trading with AI support and practice." },
  { icon: "📚", title: "Psychology", desc: "Master trading mindset with AI-powered guidance." },
  { icon: "📈", title: "Technical Analysis", desc: "Spot trends and patterns using AI-enhanced lessons." },
  { icon: "✅", title: "Fundamental Analysis", desc: "Analyze financials with simplified AI support." },
  { icon: "💱", title: "Forex", desc: "Explore currency markets and AI tools that track moves." },
  { icon: "💎", title: "Crypto", desc: "Understand crypto volatility with AI charts." },
  { icon: "🔗", title: "Defi", desc: "Unpack DeFi protocols with guided walkthroughs." },
  { icon: "⚖️", title: "Derivatives", desc: "Learn options and futures the AI-assisted way." },
  { icon: "↔️", title: "Spread", desc: "Trade spreads with live support from AI hints." },
  { icon: "📅", title: "Futures", desc: "Get clarity on futures contracts with AI forecasting." },
  { icon: "🤖", title: "Algorithmic Trading", desc: "Automate your strategy — or at least understand how." },
  { icon: "📊", title: "TradingView", desc: "Navigate and analyze with chart tools + AI tips." },
  { icon: "🎯", title: "Options", desc: "Simplify complex setups with FinTorro AI Agents." },
  { icon: "📜", title: "PineScript", desc: "Code, test, and visualize indicators via AI help." },
  { icon: "🌍", title: "Financial Markets", desc: "Understand the big picture with global market AI tools." },
  { icon: "🏢", title: "Stocks", desc: "Learn to analyze and trade equities with smart guidance." },
  { icon: "📄", title: "Bonds", desc: "Uncover income strategies with AI-backed clarity." },
  { icon: "💰", title: "Investing", desc: "Build long-term wealth with AI-assisted insights." },
  { icon: "🧠", title: "Smart Money Concepts", desc: "Understand what institutions look for — explained by AI." },
  { icon: "🧠", title: "Prop Funding Concepts", desc: "Understand how to pass challenges of prop firms — explained by AI." },
];

const CoursesSection = () => (
  <section id="courses" className="courses-section">
    <div className="container">
      <h2>Learn Trading & Investing with 20+ AI-Powered Courses</h2>
      <div className="steps-grid">
        {courses.map((c, i) => (
          <a href="/aha-moment" key={i} className="step">
            <span className="icon-placeholder">{c.icon}</span>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default CoursesSection;
